import { render, staticRenderFns } from "./ItemTypeGroupTable.vue?vue&type=template&id=0be3148a"
import script from "./ItemTypeGroupTable.vue?vue&type=script&lang=js"
export * from "./ItemTypeGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports